import React from "react";
import {connect} from "react-redux";
import {Query} from "react-apollo";
import PanelGroupController from "../../../components/PanelGroupController";
import ActionButton from "../../../components/ActionButton";
import {GET_STOCK_TRANSFER} from "../../../queries/stockTransfers";
import {
  requestEditStockTransfer,
  requestAddPalletToTransfer,
  requestAddManualPalletToTransfer,
  requestDispatchStockTransfer,
  requestReceiveStockTransfer,
  requestCancelStockTransfer,
  requestDiscardStockTransfer,
} from "../../../actions/StockTransferApiActions";
import gql from "graphql-tag";
import {AdviceSentButton} from "../../shared/AdviceSent";
import ShipmentAdviceButtons from "./ShipmentAdviceButtons";

const SET_ADVICE_SENT = gql`
  mutation setStockTransferAdviceSent($data: SetStockTransferAdviceSentInput!) {
    setStockTransferAdviceSent(input: $data) {
      errors { key message }
    }
  }
`;

// What can be done with a transfer in its current status.
const StockTransferActionsPanel = (props) => {
  const {transferId} = props;
  return (
    <Query query={GET_STOCK_TRANSFER} variables={{id: transferId}} fetchPolicy="cache-and-network">
      {({data}) => {
        const transfer = data && data.stockTransfer;
        const status = transfer && transfer.status;
        const isDraft = status === "draft";
        const isInTransit = status === "in_transit";
        // A draft, or a transfer imported already in transit, until it is received.
        const isEditable = !!(transfer && transfer.editable);
        return (
          <PanelGroupController title="Actions">
            <ActionButton label="Edit Transfer" active={isEditable} onClick={() => props.requestEditStockTransfer(transferId)} />
            <ActionButton label="Add Pallets" active={isEditable} onClick={() => props.requestAddPalletToTransfer(transferId)} />
            <ActionButton label="Add Manual Pallet" active={isEditable} onClick={() => props.requestAddManualPalletToTransfer(transferId)} />
            <ActionButton label="Dispatch Transfer" active={isDraft} onClick={() => props.requestDispatchStockTransfer(transferId)} />
            <ActionButton label="Receive Transfer" active={isInTransit} onClick={() => props.requestReceiveStockTransfer(transferId)} />
            <AdviceSentButton
              mutation={SET_ADVICE_SENT}
              resultField="setStockTransferAdviceSent"
              input={{transferId}}
              sent={!!(transfer && transfer.adviceSent)}
              active={!!status && status !== "cancelled"} />
            <ShipmentAdviceButtons transferId={transferId} active={!!status && status !== "cancelled"} />
            <ActionButton label="Cancel Transfer" active={isDraft || isInTransit} onClick={() => props.requestCancelStockTransfer(transferId)} />
            <ActionButton label="Delete Transfer" active={!!(transfer && transfer.discardable)} onClick={() => props.requestDiscardStockTransfer(transferId)} />
          </PanelGroupController>
        )
      }}
    </Query>
  )
}

export default connect(null, {
  requestEditStockTransfer,
  requestAddPalletToTransfer,
  requestAddManualPalletToTransfer,
  requestDispatchStockTransfer,
  requestReceiveStockTransfer,
  requestCancelStockTransfer,
  requestDiscardStockTransfer,
})(StockTransferActionsPanel);
